const initialState = {
  selectedWorkshop: null
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case 'ORDER_SELECT_WORKSHOP':
      return { ...state, selectedWorkshop: action.payload.id };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/order/reducer.js